import type { VisitorState } from '~/lib/chat-visitor';
import { chatVisitor } from '~/lib/chat-visitor';
import { ChatComposer } from './ChatComposer';
import { ChatMessageList } from './ChatMessageList';

/** De wachtrij. Eerlijk over de duur, want dat is de belofte die de bezetting
 *  vooraf al deed. */
export function ChatWaiting({ state }: { state: VisitorState }) {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="flex flex-col gap-1 border-b border-hairline bg-accent-soft px-4 py-3">
        <p className="text-base font-semibold text-accent-soft-ink">We zoeken een medewerker voor je…</p>
        <p className="text-sm text-accent-soft-ink">Meestal binnen een minuut. Je kunt dit venster gerust sluiten.</p>
      </div>
      <ChatMessageList messages={state.messages} ownSide="customer" agentAvatar={state.session?.agentAvatar} />
    </div>
  );
}

export function ChatActive({ state }: { state: VisitorState }) {
  return (
    // min-h-0: zonder dat weigert een flex-kind te krimpen (min-height is
    // standaard auto) en scrollt het transcript niet, maar duwt het het
    // invoerveld uit beeld.
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <ChatMessageList
        messages={state.messages}
        ownSide="customer"
        agentAvatar={state.session?.agentAvatar}
        typingLabel={state.agentTyping ? `${state.session?.agentName ?? 'De medewerker'} typt` : null}
      />

      {state.error && (
        <p role="alert" className="border-t border-hairline bg-danger-soft px-3 py-2 text-sm text-danger">
          {state.error}
        </p>
      )}

      {/* Verbindingsstatus alleen tonen als er iets áán de hand is. Een groen
          "verbonden"-lampje dat er altijd staat leert een lezer niets. */}
      {(state.connection === 'retrying' || state.connection === 'offline') && (
        <p className="border-t border-hairline bg-warning-soft px-3 py-1.5 text-sm text-warning">
          {state.connection === 'offline' ? 'Je bent offline.' : 'Verbinding kwijt — we proberen het opnieuw…'}
        </p>
      )}

      <ChatComposer
        onSend={(text) => chatVisitor.send(text)}
        onSendImage={(file) => chatVisitor.sendImage(file)}
        onTyping={(t) => chatVisitor.typing(t)}
        busy={state.busy}
        autoFocus
      />
    </div>
  );
}

export function ChatEnded({ state }: { state: VisitorState }) {
  return (
    // min-h-0: zonder dat weigert een flex-kind te krimpen (min-height is
    // standaard auto) en scrollt het transcript niet, maar duwt het het
    // invoerveld uit beeld.
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <ChatMessageList messages={state.messages} ownSide="customer" agentAvatar={state.session?.agentAvatar} />
      <div className="flex flex-col gap-2 border-t border-hairline bg-surface p-4">
        <p className="text-sm text-ink-2">Dit gesprek is afgesloten.</p>
        <button
          type="button"
          onClick={() => void chatVisitor.newChat()}
          className="rounded-md bg-accent px-3 py-2 text-base font-semibold text-accent-on shadow-sm transition hover:bg-accent-hover hover:shadow-glow"
        >
          Nieuw gesprek
        </button>
      </div>
    </div>
  );
}
